import React from 'react';
import PropTypes from 'prop-types';
import { LTI_KINDS } from '@/components/shared/Lms/lmsProviders';
import Modal from '../../common/Modal/index';
import AssignmentForm from './AssignmentForm';
import {
  assessmentsPropType,
  classroomsPropType,
  assignmentInitialValuesPropType
} from './PropTypes';
import styles from './AssignmentModal.module.scss';
import useAssignablesStore from './WhatSection/store/useAssignablesStore';

const AssignmentModal = ({
  assessments, assessmentsPagePath, assignmentsPath, classrooms, closeModal, connectedToCanvas,
  connectedToGoogleClassroom, handlePostSave, initialIsUnit, initialLessonId, initialValues, loadingInitialValues,
  ltiKind, modalIsOpen, newRecord, program, stafferId, subscriberConnectedToCanvas, updatePath,
}) => {
  const games = useAssignablesStore(state => state.games) || [];
  const score = useAssignablesStore(state => state.score);

  return (
    <Modal
      bodyClassName={styles.modalPopup}
      className={styles.modalPopup}
      closeModal={closeModal}
      headerText={newRecord ? 'Create Assignment' : 'Edit Assignment'}
      id="CreateAssignmentModal"
      isOpen={modalIsOpen}
    >
      <AssignmentForm
        assessments={assessments}
        assessmentsPagePath={assessmentsPagePath}
        assignmentsPath={assignmentsPath}
        classrooms={classrooms}
        closeModal={closeModal}
        connectedToCanvas={connectedToCanvas}
        connectedToGoogleClassroom={connectedToGoogleClassroom}
        games={games}
        handlePostSave={handlePostSave}
        initialIsUnit={initialIsUnit}
        initialLessonId={initialLessonId}
        initialValues={initialValues}
        loadingInitialValues={loadingInitialValues}
        ltiKind={ltiKind}
        newRecord={newRecord}
        program={program}
        score={score}
        stafferId={stafferId}
        subscriberConnectedToCanvas={subscriberConnectedToCanvas}
        updatePath={updatePath}
      />
    </Modal>
  );
};

AssignmentModal.propTypes = {
  assessments: assessmentsPropType,
  assessmentsPagePath: PropTypes.string.isRequired,
  assignmentsPath: PropTypes.string.isRequired,
  classrooms: classroomsPropType,
  closeModal: PropTypes.func.isRequired,
  connectedToCanvas: PropTypes.bool,
  connectedToGoogleClassroom: PropTypes.bool,
  handlePostSave: PropTypes.func.isRequired,
  initialIsUnit: PropTypes.bool,
  initialLessonId: PropTypes.number,
  initialValues: assignmentInitialValuesPropType,
  loadingInitialValues: PropTypes.bool,
  ltiKind: PropTypes.oneOf(LTI_KINDS),
  modalIsOpen: PropTypes.bool.isRequired,
  newRecord: PropTypes.bool,
  program: PropTypes.shape({
    display_investigations_text_section: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    science: PropTypes.bool.isRequired,
  }).isRequired,
  stafferId: PropTypes.number.isRequired,
  subscriberConnectedToCanvas: PropTypes.bool,
  updatePath: PropTypes.string
};

AssignmentModal.defaultProps = {
  assessments: [],
  classrooms: [],
  connectedToCanvas: false,
  connectedToGoogleClassroom: false,
  initialIsUnit: false,
  initialLessonId: null,
  initialValues: {},
  loadingInitialValues: false,
  ltiKind: null,
  newRecord: true,
  subscriberConnectedToCanvas: false,
  updatePath: ''
};

export default AssignmentModal;
